import { InjectionToken } from '@angular/core';

export const LOCAL_PROVIDER_TOKEN = new InjectionToken<any>('locale-provider-token');
